import { ContactIntegrationStatus } from "@/components/integrations/employee/employee-integrations-sync";
import { DropdownMenuContent } from "@/components/ui/dropdown-menu";
import {
  ContactCrmIntegration,
  CrmIntegrationProviderSupported,
} from "@shaarp/common";
import { CreateNewContact } from "./create-new-contact";
import { SearchResults } from "./search-results";
import { SyncedIntegrations } from "./synced-integrations";

type IntegrationDropdownContentProps = {
  integrations: ContactIntegrationStatus[];
  onSync: (
    integrationKey: CrmIntegrationProviderSupported,
    externalContactId?: string,
  ) => void;
  onOpenExternal: (crmContact: ContactCrmIntegration) => void;
};

/**
 * One section per connected CRM: a contact can be in one and not the other, and
 * a single synced/unsynced flag would hide the half still waiting to be sent.
 */
export const IntegrationDropdownContent = ({
  integrations,
  onSync,
  onOpenExternal,
}: IntegrationDropdownContentProps) => {
  const syncedIntegrations = integrations.filter(
    (integration) => integration.isSynced,
  );
  const unsyncedIntegrations = integrations.filter(
    (integration) => !integration.isSynced,
  );

  return (
    <DropdownMenuContent align="end" className="p-2 w-96">
      {syncedIntegrations.length > 0 && (
        <SyncedIntegrations
          integrations={syncedIntegrations}
          onSync={onSync}
          onOpenExternal={onOpenExternal}
        />
      )}

      {unsyncedIntegrations
        .filter((integration) => integration.possibleMatches.length === 0)
        .map((integration) => (
          <CreateNewContact
            key={integration.key}
            integration={integration}
            onSync={onSync}
          />
        ))}

      {unsyncedIntegrations
        .filter((integration) => integration.possibleMatches.length > 0)
        .map((integration) => (
          <SearchResults
            key={integration.key}
            integration={integration}
            possiblesMatchCrmContacts={integration.possibleMatches}
            onSyncToContact={(externalContactId) =>
              onSync(integration.key, externalContactId)
            }
            onOpenExternal={onOpenExternal}
          />
        ))}
    </DropdownMenuContent>
  );
};
